module.exports = "<div class=\"modal-body\">\r\n  <p>La operación se realizará en <b class=\"text-orange\">{{ time }}</b>, aún tienes tiempo de cancelar</p>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-danger\" \r\n  (click)=\"activeModal.close()\">Cancelar</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/timing/timing.component.html
// module id = ../../../../../src/app/components/modals/timing/timing.component.html
// module chunks = main